<style>
.el-collapse-item__header {
  padding-left: 15px;
}

.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}

.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}

.v-modal {
  z-index: 100 !important;
}

.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}

.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}

.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

.detail-row {
  display: flex;
  padding: 0 20px;
}

.detail-row .item {
  display: flex;
  flex: 1;
  align-items: center;
}

.detail-row .item .tittle {
  width: 110px;
  text-align: left;
}

.detail-row .item .content {
  width: 500px;
  text-align: left;
}

.detail-row .pdf-container img {
  width: 40px;
  height: 40px;
}

.detail-row .item .pdf-container {
  width: auto;
  text-align: center;
}
</style>
<style >
.contract .el-form-item__content {
  margin-left: 0 !important;
}
</style>
<template>
  <div class="content contract" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8">
          <div class="search-area-div">公司名称：</div>
          <el-select v-model="page.tenantGuid" filterable placeholder="请选择" class="ipt-sty" @change="tenantChange">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>

        <el-col :span="8">
          <div class="search-area-div">报告月份：</div>
          <el-date-picker class="ipt-sty" v-model="timeRange" type="monthrange" align="left" unlink-panels
            range-separator="-" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM" :clearable="false">
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <el-button size="medium" type="info" @click="search">搜索</el-button>
          <el-button size="medium" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
      <div style="padding: 20px 20px 0 0; text-align: right"></div>
    </div>

    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="addContract">新增运营报告</el-button>
    </div>
    <div class="back-color-fff">
      <el-table :data="tableData" border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>

        <el-table-column prop="tenantName" label="所属公司" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.tenantName }}</template>
        </el-table-column>

        <el-table-column prop="reportMonth" label="报告月份" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.reportMonth }}</template>
        </el-table-column>
        <el-table-column prop="reportNote" label="报告简述" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.reportNote }}</template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="contractYear" label="创建人" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="250" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="downloadFile(scope.row.reportFile)">下载报告 ｜</a>
            <a class="txt-color" @click="editContract(scope.row)">编辑 ｜</a>
            <a class="txt-color" style="color: red !important" @click="delContract(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange" :page-sizes="[10, 100, 200]" :current-page="page.pageIndex"
      :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>

    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="700px">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">所属公司 </span>
          <el-select v-model="tenantGuid" filterable placeholder="请选择" class="fl" style="width: 400px"
            @change="tenantChange">
            <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">关联任务包 </span>
          <el-select :disabled="this.guid!=''" v-model="taskGuid" multiple placeholder="请选择" class="fl" style="width: 400px" filterable>
            <el-option v-for="item in taskList" :key="item.guid" :label="item.taskTitle" :value="item.guid">
            </el-option>

          </el-select>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">报告月份 </span>
          <el-date-picker class="fl" style="width: 400px" v-model="reportMonth" type="month" placeholder="选择日期时间"
            value-format="yyyy-MM">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">报告简述 </span>
          <el-input class="fl" style="width: 400px" type="textarea" :rows="5" :maxlength="200" placeholder="最多可输入200个字"
            v-model="reportNote">
          </el-input>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">报告文件 </span>
          <el-upload class="upload-demo fl t-left" action="#" multiple :limit="10"
            accept=".pdf,.PDF,.docx,.xlsx,.doc,.xlsm" :on-exceed="handleExceed" :http-request="uploadPdf"
            :file-list="filePdfAttachList" :on-remove="handlePdfRemove">
            <el-button size="medium" type="info">点击上传文件</el-button>
            <div slot="tip" class="el-upload__tip">
              当前支持 word、pdf、excel，请使用 Office 2010 及以上版本，否则可能出现乱码
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '新增运营报告'" @click="addReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
        <el-button size="medium" type="info" v-else @click="updateReqVersion"
          v-loading.fullscreen.lock="fullscreenLoading">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    return {
      fullscreenLoading: false,
      textTitle: '新增运营报告',
      dialogVisible: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        startTime: '',
        endTime: '',
        selfTenantGuid:localStorage.guid,
      },
      timeRange: '',

      taskGuid: [],

      tenantName: '',
      tenantGuid: '',

      reportMonth: '',
      reportNote: '',
      guid: '',
      tableLoading: false,
      tableData: [],
      height: window.innerHeight - 400,
      right: 'right',

      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      filePdfAttachList: [],
      detail: {},
      tenantList: [],
      allTakList: [],
      taskList: [],
      taskGroup: [],
    };
  },
  created() {
    this.getTenantList();
    this.getAlltaskList();
  },
  watch: {
    tenantGuid(newVal) {
      if (newVal) {
        this.getTaskList(newVal);
      }
    },
  },
  methods: {
    tenantChange() {
      this.taskGuid = [];
      this.taskGroup = [];
    },
    getTenantList() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tenantList = res.data.data;
          // self.page.tenantGuid = self.tenantList[0].sendTenantGuid;
          self.getList();

        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handlePdfRemove(file) {
      let self = this;
      self.filePdfAttachList.forEach(function (j, ind) {
        if ((j.url||j.path) == (file.url||file.path)) {
          self.filePdfAttachList.splice(ind, 1);
        }
      });
    },
    downloadFile(reportFile) {
      let list = [];
      if (!reportFile) {
        this.$message.error('请上传运营报告');
        return;
      }
      if (reportFile.indexOf('{') > -1) {
        list = JSON.parse(reportFile)
      } else {
        list = [{
          name: '',
          path: reportFile
        }]
      }
  
      list.forEach(item => {
        if(item.path.indexOf('pdf')>-1){
          window.open(item.path + '?response-content-type=application/octet-stream');
        }
        this.down(item.path)
      })
    },
    down(url) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";  // 防止影响页面
      iframe.style.height = 0;  // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe);  // 这一行必须，iframe挂在到dom树上才会发请求
      // 5分钟之后删除（onload方法对于下载链接不起作用）
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    getTaskList(tenantGuid) {
      let self = this;

      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid,
        payState: this.guid ? null : '未结算',
        state: this.guid ? null : ['已派发', '待上传'],
        notState: this.guid ? null : ['已失效'],
        isService: this.guid ? null : 'Y'
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records) {
            self.taskList = res.data.data.records;
            self.getAlltaskList();

          } else {
            self.taskList = []
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    search() {
      let self = this;
      if (self.timeRange && self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0];
        self.page.endTime = self.timeRange[1];
      }
      let req = {
        pageIndex: 1,
        pageSize: 10,
        tenantName: self.page.tenantName,
        startTime: self.page.startTime,
        endTime: self.page.endTime,
        tenantGuid: self.page.tenantGuid,
        selfTenantGuid: self.page.selfTenantGuid,
      };
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/operation/get-list`, req).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        startTime: '',
        endTime: '',
        selfTenantGuid: localStorage.guid
      };
      // this.page.tenantGuid =  this.tenantList[0].sendTenantGuid;
      this.timeRange = '';
      this.getList();
    },
    addContract() {
      this.textTitle = '新增运营报告';
      this.guid = '';
      this.taskGuid = [];
      this.taskList = [];
      this.tenantGuid = '';
      this.tenantName = '';
      this.reportMonth = '';
      this.reportNote = '';
      this.filePdfAttachList = [];
      this.dialogVisible = true;
    },
    editContract(detail) {
      this.filePdfAttachList = [];
      this.textTitle = '修改运营报告';
      this.guid = detail.guid;
      this.tenantName = detail.tenantName;
      this.tenantGuid = detail.tenantGuid;
      this.reportMonth = detail.reportMonth;
      this.reportNote = detail.reportNote;
      let taskGroup = JSON.parse(detail.taskGroup);
      this.taskGroup = taskGroup;
      this.taskGuid = [];
      if (taskGroup) {
        taskGroup.forEach((item) => {
          this.taskGuid.push(item.guid);
        });
      }
      if (detail.reportFile && detail.reportFile.indexOf('{') > -1) {
        this.filePdfAttachList = JSON.parse(detail.reportFile);
      } else if (detail.reportFile && detail.reportFile.indexOf('object') > -1) {
        this.filePdfAttachList = []
      } else {
        this.filePdfAttachList = [{
          name: detail.reportFileName,
          path: detail.reportFile
        }]
        console.log(this.filePdfAttachList)
      }


      this.dialogVisible = true;
    },
    getList() {
      let self = this;
      if (self.timeRange && self.timeRange.length != 0) {
        self.page.startTime = self.timeRange[0];
        self.page.endTime = self.timeRange[1];
      }
      self.tableLoading = true;
      self.api
        .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/operation/get-list`, this.page)
        .then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    getAlltaskList() {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        isService: 'Y'
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data.records) {
            self.allTakList = res.data.data.records;
            self.taskGuid.forEach(i => {
              self.allTakList.forEach(j => {
                if (i == j.guid) {
                  self.taskList.push(j)
                }
              })
            })
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });

    },
    delContract(guid) {
      var self = this;
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/operation/delete?guid=${guid}`)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
        });
    },
    addReqVersion() {
      var self = this;
      if (!this.tenantGuid) {
        self.$message('请选择公司');
        return;
      }
      if (this.taskGuid && this.taskGuid.length == 0) {
        self.$message('请关联任务包');
        return;
      }
      if (!this.reportMonth) {
        self.$message('请选择报告月份');
        return;
      }
      if (!this.reportNote) {
        self.$message('请输入报告简述');
        return;
      }
      if (this.filePdfAttachList.length == 0) {
        self.$message('请上传文件');
        return;
      }
      var taskGroup = [];
      this.taskGuid.forEach((i) => {
        this.allTakList.forEach((j) => {
          if (j.guid == i) {
            taskGroup.push({
              guid: j.guid,
              taskTitle: j.taskTitle,
            });
          }
        });
      });
      var tenantList = this.tenantList;
      var tenantObj = tenantList.find((item) => item.sendTenantGuid == this.tenantGuid);
      var reportFile = [];
      this.filePdfAttachList.forEach(item => {
        reportFile.push({
          name: item.name,
          path: item.url || item.path
        })
      })
      var req = {
        taskGroup: JSON.stringify(taskGroup),
        tenantGuid: this.tenantGuid,
        tenantName: tenantObj.sendTenantName,
        reportNote: this.reportNote,
        reportMonth: this.reportMonth,
        reportFile: JSON.stringify(reportFile),
      };
      this.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/operation/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          this.fullscreenLoading = false;
          self.$message.success('新增成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    updateReqVersion(isOpen) {
      var self = this;
      if (!this.tenantGuid) {
        self.$message('请选择公司');
        return;
      }
      if (this.taskGuid && this.taskGuid.length == 0) {
        self.$message('请关联任务包');
        return;
      }
      if (!this.reportMonth) {
        self.$message('请选择报告月份');
        return;
      }
      if (!this.reportNote) {
        self.$message('请输入报告简述');
        return;
      }
      if (this.filePdfAttachList.length == 0) {
        self.$message('请上传文件');
        return;
      }
      var taskGroup = [];
      this.taskGuid.forEach((i) => {
        this.allTakList.forEach((j) => {
          if (j.guid == i) {
            taskGroup.push({
              guid: j.guid,
              taskTitle: j.taskTitle,
            });
          }
        });
      });
      let reportFile = [];
      this.filePdfAttachList.forEach(item => {
        reportFile.push({
          name: item.name,
          path: item.url || item.path
        })
      })
      var tenantList = this.tenantList;
      var tenantObj = tenantList.find((item) => item.sendTenantGuid == this.tenantGuid);
      var req = {
        taskGroup: JSON.stringify(taskGroup),
        tenantGuid: this.tenantGuid,
        tenantName: tenantObj.sendTenantName,
        reportNote: this.reportNote,
        reportMonth: this.reportMonth,
        reportFile: JSON.stringify(reportFile),
        guid: this.guid,
      };
      this.fullscreenLoading = true;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/tenant-biz/operation/edit`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.dialogVisible = false;
          this.fullscreenLoading = false;
          self.$message.success('编辑成功');
          self.page.pageIndex = 1;
          self.getList();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

    handleExceed(files, filePdfAttachList) {
      this.$message.warning(`当前限制选择 10 个文件`);
    },
    uploadPdf(file) {
      let self = this;
      console.log(file.file);
      let formData = new FormData();
      formData.append('image', file.file);
      self.api
        .postImage(self.urlImg, formData)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let item = {
              name: file.file.name,
              url: res.data.data,
            };
            self.filePdfAttachList.push(item);
            self.$message.success('上传成功');
          } else {
            elf.$message.error('上传失败,请重新上传!');
          }
        })
        .catch(() => {
          self.$message('上传失败,请重新上传');
        });
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

/* .el-range-editor.el-input__inner {
  padding: 0px;
} */
/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
</style>